import React from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

export function StageLoading({ color, title, sub }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center text-center anim-fade-up" data-testid="stage-loading">
      <div className="relative mb-6 h-14 w-14">
        <div className="absolute inset-0 rounded-full border-2 border-white/10" />
        <div
          className="absolute inset-0 animate-spin rounded-full border-2 border-transparent"
          style={{ borderTopColor: color, animationDuration: "0.9s" }}
        />
      </div>
      <div className="font-display text-2xl" style={{ color }}>{title}</div>
      {sub && <div className="mt-2 max-w-sm text-sm text-muted">{sub}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center text-center anim-fade-up" data-testid="error-state">
      <AlertTriangle className="mb-4 h-10 w-10 text-ros" />
      <div className="font-display text-xl text-ink">Something interrupted this step</div>
      <p className="mt-2 max-w-md text-sm text-muted">{message}</p>
      {onRetry && (
        <button
          data-testid="error-retry-btn"
          onClick={onRetry}
          className="mt-5 inline-flex items-center gap-2 rounded-full border border-ros/50 bg-ros/10 px-5 py-2 text-sm font-medium text-ros transition-colors hover:bg-ros/20"
        >
          <RefreshCw className="h-4 w-4" /> Try again
        </button>
      )}
    </div>
  );
}
